import React from 'react';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

import './feature.css';
import { Link } from 'react-router-dom';

const Features = () => {
  return (
    <section className="section" id="features">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="text-center mb-5">
              <h6 style={{ color: '#747d7b' }}>WHY OASYS?</h6>
              <h1 className="mb-3 ff-secondary fw-semibold lh-base">
                Empower Event Sponsorship
              </h1>
              <p className="text-muted">
                Transform the way you manage event sponsorships and foster impactful collaborations effortlessly. Oasys is your all-in-one solution, designed for seamless sponsorship management that maximizes efficiency, reduces costs, and leaves a lasting impact.
              </p>
            </div>
          </div>
          {/* end col */}
        </div>
        {/* end row */}

        <div className="row align-items-center gy-4">
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="text-muted">
              <h5 className="fs-12 text-uppercase text-success" style={{ color: '#d9c4ab' }}>
                Vendor Marketplace
              </h5>
              <h4 className="mb-3">Curate an event with stress free logistics through the vendor marketplace</h4>
              <p className="mb-4 ff-secondary">
                Oasys features a dedicated portal for a wide range of credible event vendors that are sorted by region, ensuring the beneficiaries get served fast with a focus on quality and affordable services to make your event a success.
              </p>
              <div className="mt-4">
                <Link to="/" className="btn btn-primary">
                Discover how Oasys transformed disbursement of sponsorship resources <ArrowRightAltIcon/>
                </Link>
              </div>
            </div>
          </div>
          {/* end col */}
          <div className="col-lg-6 col-sm-7 col-10 ms-auto order-1 order-lg-2">
            <div>
              <img src="assets/images/features/Meet.jpeg" alt="" className="img-fluid" />
            </div>
          </div>
        </div>
        {/* end row */}

        <div className="row align-items-center mt-5 pt-lg-5 gy-4">
          <div className="col-lg-6 col-sm-7 col-10 mx-auto">
            <div>
              <img src="assets/images/features/Meet2.png" alt="" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="text-muted ps-lg-5">
              <h5 className="fs-12 text-uppercase text-success" style={{ color: '#d9c4ab' }}>
                Fast & Secure
              </h5>
              <h4 className="mb-3">Empower your event with reliable payouts that don't let you down at your time of need</h4>
              <p className="mb-4">
                The platform facilitates fast and secure disbursement of funds to beneficiaries from any part of the globe, ensuring trust and peace of mind, allowing you to focus on making your event a success.
              </p>

              <div className="vstack gap-2">
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <div className="avatar-xs icon-effect">
                      <div className="avatar-title bg-transparent text-success rounded-circle h2">
                        <i className="ri-check-fill"></i>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0">Instantaneous disbursement</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <div className="avatar-xs icon-effect">
                      <div className="avatar-title bg-transparent text-success rounded-circle h2">
                        <i className="ri-check-fill"></i>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0">Secure transactions</p>
                  </div>
                </div>
                {/* <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <div className="avatar-xs icon-effect">
                      <div className="avatar-title bg-transparent text-success rounded-circle h2">
                        <i className="ri-check-fill"></i>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0">Targeted Packages</p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          {/* end col */}
        </div>
        {/* end row */}

        <div className="row align-items-center mt-5 pt-lg-5 gy-4">
          <div className="col-lg-6 col-sm-7 col-10 mx-auto">
            <div className="text-muted">
              <h5 className="fs-12 text-uppercase text-success" style={{ color: '#d9c4ab' }}>
                AI Integration
              </h5>
              <h4 className="mb-3">Leverage the power of Artificial Intelligence to reduce process times and administrative costs</h4>
              <p className="mb-4 ff-secondary">
                Through the integration of Artificial Intelligence in the sponsorship workflow, we are taking the hustle out of the process by automating tedious tasks, improving fraud prevention and reducing errors thus cutting down on process time by at least 50% and decreasing administrative costs.
              </p>
              <div className="vstack gap-2">
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <div className="avatar-xs icon-effect">
                      <div className="avatar-title bg-transparent text-success rounded-circle h2">
                        <i className="ri-check-fill"></i>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0">Fraud prevention</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <div className="avatar-xs icon-effect">
                      <div className="avatar-title bg-transparent text-success rounded-circle h2">
                        <i className="ri-check-fill"></i>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0">Task automation</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <div className="avatar-xs icon-effect">
                      <div className="avatar-title bg-transparent text-success rounded-circle h2">
                        <i className="ri-check-fill"></i>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0">Error reduction</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end col */}
          <div className="col-lg-6 col-sm-7 col-10 ms-auto order-1 order-lg-2">
            <div>
              <img src="assets/images/features/Meet3.jpg" alt="" className="img-fluid" />
            </div>
          </div>
        </div>
        {/* end row */}
      </div>
      {/* end container */}
    </section>
  );
};

export default Features;
